var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    clipPath: "url(#clip0_745_1237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.10156 10.4906H13.3984C13.9067 10.4906 14.3187 10.0786 14.3187 9.57031C14.3187 9.06205 13.9067 8.65 13.3984 8.65H4.10156C3.5933 8.65 3.18125 9.06205 3.18125 9.57031C3.18125 10.0786 3.5933 10.4906 4.10156 10.4906Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2109 11.9312H4.10156C3.5933 11.9312 3.18125 12.3433 3.18125 12.8516C3.18125 13.3598 3.5933 13.7719 4.10156 13.7719H11.2109C11.7192 13.7719 12.1312 13.3598 12.1312 12.8516C12.1312 12.3433 11.7192 11.9312 11.2109 11.9312Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2109 15.2125H4.10156C3.5933 15.2125 3.18125 15.6246 3.18125 16.1328C3.18125 16.6411 3.5933 17.0531 4.10156 17.0531H11.2109C11.7192 17.0531 12.1312 16.6411 12.1312 16.1328C12.1312 15.6246 11.7192 15.2125 11.2109 15.2125Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2109 18.4937H4.10156C3.5933 18.4937 3.18125 18.9058 3.18125 19.4141C3.18125 19.9223 3.5933 20.3344 4.10156 20.3344H11.2109C11.7192 20.3344 12.1312 19.9223 12.1312 19.4141C12.1312 18.9058 11.7192 18.4937 11.2109 18.4937Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.7893 19.0147L27.8304 23.0559C28.1899 23.4153 28.1899 23.9979 27.8304 24.3573C27.8304 24.3573 27.8303 24.3573 27.8303 24.3573M23.7893 19.0147L26.5996 24.2866C26.7598 24.4468 26.9697 24.5269 27.1796 24.5269C27.3895 24.5269 27.5995 24.4468 27.7596 24.2866L27.8303 24.3573M23.7893 19.0147C25.4459 16.7319 25.2466 13.5115 23.1901 11.4549C22.6735 10.9383 22.0768 10.5306 21.4281 10.2428V6.28906C21.4281 6.045 21.3312 5.81093 21.1585 5.63834C21.1585 5.63833 21.1585 5.63833 21.1585 5.63832L15.69 0.169599C15.5175 -0.00300015 15.2833 -0.1 15.0393 -0.1L3.00781 -0.1C1.29408 -0.1 -0.1 1.29408 -0.1 3.00781L-0.1 24.9922C-0.1 26.7059 1.29408 28.1 3.00781 28.1H18.3203C20.034 28.1 21.4281 26.7059 21.4281 24.9922V20.9291C21.8005 20.7639 22.1557 20.5591 22.4884 20.3168M23.7893 19.0147L22.4884 20.3168M27.8303 24.3573C27.6507 24.5371 27.4149 24.6269 27.1796 24.6269C26.9443 24.6269 26.7086 24.537 26.5289 24.3573L22.4884 20.3168M27.8303 24.3573L22.4884 20.3168M21.8886 18.4155C21.4259 18.8782 20.8699 19.2126 20.2635 19.4032C20.2434 19.4087 20.2238 19.4149 20.2045 19.4216C19.8376 19.5306 19.4528 19.5875 19.059 19.5875C17.99 19.5875 16.9854 19.1714 16.2295 18.4155C15.4735 17.6595 15.0575 16.655 15.0575 15.5859C15.0575 14.5169 15.4735 13.5124 16.2295 12.7564C16.9854 12.0005 17.99 11.5844 19.059 11.5844C19.4529 11.5844 19.8378 11.6412 20.2048 11.7503C20.2239 11.757 20.2434 11.7631 20.2632 11.7685C20.8697 11.9591 21.4258 12.2936 21.8886 12.7564C23.4487 14.3166 23.4486 16.8553 21.8886 18.4155ZM15.9594 3.04218L18.286 5.36875H15.9594V3.04218ZM19.5875 24.9922C19.5875 25.6908 19.0189 26.2594 18.3203 26.2594H3.00781C2.30917 26.2594 1.74062 25.6908 1.74062 24.9922L1.74062 3.00781C1.74062 2.30917 2.30917 1.74063 3.00781 1.74063L14.1187 1.74063V6.28906C14.1187 6.79732 14.5308 7.20937 15.0391 7.20937H19.5875V9.76755C19.4129 9.7519 19.2366 9.74375 19.059 9.74375C17.4987 9.74375 16.0312 10.3516 14.928 11.4549C13.8247 12.5582 13.2168 14.0257 13.2168 15.5859C13.2168 17.1463 13.8247 18.6137 14.928 19.717C16.0312 20.8203 17.4987 21.4281 19.059 21.4281C19.2366 21.4281 19.4129 21.42 19.5875 21.4043V24.9922Z",
    fill: "#29185E",
    stroke: "#29185E",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_1237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/dictionary.f91dc61facf1d0cceee595864b9eb40d.svg";
export { ForwardRef as ReactComponent };